import { ReactLocalization } from "@fluent/react";
import { FluentBundle, FluentResource } from "@fluent/bundle";
import messages from "./messages.ftl?raw";

const getLocalizationInfo = (messagesStr: string) => {
  const bundle = new FluentBundle(["en-US"]);
  const resource = new FluentResource(messagesStr);
  bundle.addResource(resource);
  function* generateBundles(_locales: string[]) {
    yield bundle;
  }
  // Pass null parseMarkup to disable React-Overlay support; the default
  // parser touches `document`, which doesn't exist during the framework-mode
  // SPA prerender (Node).
  const localization = new ReactLocalization(
    generateBundles(["en-US"]),
    null,
  );

  return localization;
};

const localization = getLocalizationInfo(messages);

export default localization;
